/* globals appendQueryParam */
(function () {
	'use strict';
	angular.module('app.core')
		.service('tableService', tableService);

	tableService.$inject = ['$http', '$rootScope', '$compile', '$q', '$timeout', 'leanFilterService', 'URLS', 'FIRST_VIEW', 'storeService'];

	function tableService($http, $rootScope, $compile, $q, $timeout, leanFilterService, URLS, FIRST_VIEW, storeService) {
		var service = {
			getData: getData,
			postData: postData,
			getConfig: getConfig,
			deleteConfig: deleteConfig,
			updateConfig: updateConfig,
			updateSiteLevelDefaultConfig: updateSiteLevelDefaultConfig,
			getSiteLevelDefaultConfig: getSiteLevelDefaultConfig,
			trackPageView: trackPageView
		};
		return service;

		function getTimeoutPromise() {
			return $q(function (resolve, reject) {
				setTimeout(function () {
					resolve({ data: { pagingResultsTimedOut: true }});
				}, 5000);
			});
		}

		function getData(params, extraParams) {
			var pageUrl;
			var responseList = [{'data': []}, {'total': 0}, {'status': 0}];

			trackPageView(params.reportName, leanFilterService.getFactoryList());

			if (params.noPaging) {
				pageUrl = buildUrl(params, extraParams, undefined, false, params.usePost);
				if (params.usePost) {
					return $http.post(pageUrl, getMultiSelectFilterQueryParams(), {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then(function (result) {
						responseList[0] = result.data;
						responseList[2].status = result.status;
						return responseList;
					});
				} else {
					return $http.get(pageUrl).then(function (result) {
						responseList[0] = result.data;
						responseList[2].status = result.status;
						return responseList;
					});
				}
			} else {
				pageUrl = buildUrl(params, extraParams, params.sort, false, params.usePost);
				var countUrl = buildUrl(params, extraParams, params.sort, true, params.usePost);

				var pagePromise;
				var countPromise;
				var countRace;
				var canceller = $q.defer();

				if (params.usePost) {
					pagePromise = $http.post(pageUrl, getMultiSelectFilterQueryParams(), {headers: {'Content-Type': 'application/x-www-form-urlencoded'}});
					countPromise = $http.post(countUrl, getMultiSelectFilterQueryParams(), { timeout: canceller.promise, headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
					countRace = $q.race([
						countPromise,
						getTimeoutPromise()
					]);
				} else {
					pagePromise = $http.get(pageUrl);
					countPromise = $http.get(countUrl, { timeout: canceller.promise });
					countRace = $q.race([
						countPromise,
						getTimeoutPromise()
					]);
				}
				return $q.all([pagePromise, countRace]).then(function (results) {
					angular.forEach(results, function (response, index) {
						responseList[index] = response.data;
					});
					if (responseList[1].pagingResultsTimedOut) {
						canceller.resolve();
					}
					return responseList;
				}, function(error) {
					responseList[2].status = error.status;
					return responseList;
				});
			}
		}

		function postData(params, extraParams, columns, includeAllColumns) {
			var url,
				body = {};
			var responseList = [{'data': []}, {'total': 0}, {'status': 0}];

			var factoryNdxString = leanFilterService.getFactoryList();

			url = (params.noFactory ? URLS.noFactoryPrefix : URLS.apiPrefix) +
				String.format(params.url, factoryNdxString);

			body.filters = leanFilterService.getFiltersForPost();

			if (extraParams && extraParams.length != 0) {
				body.extraParams = {};
				extraParams.forEach(function(param) {
					if (param.name !== undefined) {
						body.extraParams[param.name]  = param.value;
					}
				});
			}

			// Undefined checks added because arrays are initialized with empty insides, but not undefined.
			if (params.sort && params.sort[0]) {
				body.sorters = params.sort;
			}

			body.paging = {
				start: params.start,
				limit: params.number
			};

			body.extendedColumns = {
				'requestedColumns': columns.length ? columns.map(function (c) { return c.id; }) : [],
				'includeAllColumns': includeAllColumns
			};
			var canceller = $q.defer();
			var rowsPromise = $http.post(url, _.merge({operation:'rows'}, body));
			var countPromise = $http.post(url, _.merge({ operation: 'count' }, body), { timeout: canceller.promise });
			var countRace = $q.race([
				countPromise,
				getTimeoutPromise()
			]);

			trackPageView(params.reportName, factoryNdxString);

			return $q.all([rowsPromise, countRace])
			.then(function(results) {
				results = results.map(
					function(result) {
						return result.data;
					}
				);
				if (results[1].pagingResultsTimedOut) {
					canceller.resolve();
				}
				if (results[1].headerTotal) {
					results[0].headerTotals = [ { headerTotal: results[1].headerTotal } ];
				}
				return results;
			}, function(error) {
				responseList[2].status = error.status;
				return responseList;
			});
		}

		function getConfig(reportName, useCustomer, isGlobalReportSetting, factoryNdx) {
			var url = URLS.apiPrefix + (factoryNdx || globalConfig.factory.id) + '/ReportSettings/' + reportName;
			var extraParams = {};
			if (useCustomer) {
				extraParams['type'] = 'customer';
			}
			if (isGlobalReportSetting) {
				extraParams['type'] = 'global';
			}
			url = addQueryParam(url, null, extraParams, false);
			return $http.get(url)
				.then(getConfigComplete)
				.catch(getConfigFailed);

			function getConfigComplete(response) {
				if (response.status === 204) {
					return getDefaultConfig();
				}
				response.data.reportSettingsName = reportName;
				return response.data;
			}

			function getConfigFailed(error) {
				return getDefaultConfig();
			}
			
			function getDefaultConfig() {
				return {
					filters: leanFilterService.getDefaultFilters(),
					recordsPerPage: 50,
					search: '',
					columns: [],
					defaultConfig: true,
					reportSettingsName: reportName
				};
			}
		}

		function deleteConfig(reportName, useCustomer, isGlobalReportSetting, factoryNdx) {
			var url = URLS.apiPrefix + (factoryNdx || globalConfig.factory.id) + '/ReportSettings/' + reportName;
			var extraParams = {};
			if (useCustomer) {
				extraParams['type'] = 'customer';
			}
			if (isGlobalReportSetting) {
				extraParams['type'] = 'global';
			}
			url = addQueryParam(url, null, extraParams, false);
			return $http.delete(url)
				.then(deleteConfigComplete)
				.catch(deleteConfigFailed);

			function deleteConfigComplete(response) {
				return response.data;
			}

			function deleteConfigFailed(error) {
				return undefined;
			}
		}

		function getSiteLevelDefaultConfig(factoryNdx, reportName, ignoreDefaultFilters) {
			var url = URLS.apiPrefix + factoryNdx + '/ReportSettings/SiteReportSettingsDefault/' + reportName;
			var extraParams = {};
			url = addQueryParam(url, null, extraParams, false);
			return $http.get(url)
				.then(getConfigComplete)
				.catch(getConfigFailed);

			function getConfigComplete(response) {
				if (response.status === 204) {
					return getDefaultConfig();
				}
				response.data.reportSettingsName = reportName;
				return response.data;
			}

			function getConfigFailed(error) {
				return getDefaultConfig();
			}
			
			function getDefaultConfig() {
				return {
					filters: ignoreDefaultFilters ? []: leanFilterService.getDefaultFilters(),
					recordsPerPage: 50,
					search: '',
					columns: [],
					defaultConfig: true,
					reportSettingsName: reportName
				};
			}
		}

		function updateConfig(reportName, config, useCustomer, isGlobalReportSetting) {
			config.userModified = true;

			// don't send defaultConfig to backend
			var strippedConfig = {};
			for (var key in config) {
				if (key !== 'defaultConfig') {
					strippedConfig[key] = config[key];
				}
			}
			strippedConfig.config = strippedConfig.config || {};
			strippedConfig.reportName = strippedConfig.reportName || reportName;
			strippedConfig.baseReportName = strippedConfig.baseReportName || reportName;
			strippedConfig.viewType = strippedConfig.viewType || FIRST_VIEW.REPORTSETTINGSNAME_TO_VIEWTYPE[strippedConfig.baseReportName] || '';
			var url = URLS.apiPrefix + globalConfig.factory.id + '/ReportSettings/' + reportName;
			var extraParams = {};
			if (useCustomer) {
				extraParams['type'] = 'customer';
			}
			if (isGlobalReportSetting) {
				extraParams['type'] = 'global';
			}
			url = addQueryParam(url, null, extraParams, false);

			return $http.put(url, strippedConfig)
				.then(updateConfigComplete)
				.catch(updateConfigFailed);

			function updateConfigComplete(response) {
				return response.data;
			}

			function updateConfigFailed(error) {
				return undefined;
			}
		}

		function updateSiteLevelDefaultConfig(factoryNdx, reportName, config) {
			config.userModified = true;

			// don't send defaultConfig to backend
			var strippedConfig = {};
			for (var key in config) {
				if (key !== 'defaultConfig') {
					strippedConfig[key] = config[key];
				}
			}
			var extraParams = {};
			strippedConfig.config = strippedConfig.config || {};
			strippedConfig.reportName = strippedConfig.reportName || reportName;
			strippedConfig.baseReportName = strippedConfig.baseReportName || reportName;
			strippedConfig.viewType = strippedConfig.viewType || FIRST_VIEW.REPORTSETTINGSNAME_TO_VIEWTYPE[strippedConfig.baseReportName] || '';
			var url = URLS.apiPrefix + factoryNdx + '/ReportSettings/SiteReportSettingsDefault/' + reportName;
			
			url = addQueryParam(url, null, extraParams, false);

			return $http.put(url, strippedConfig)
				.then(updateConfigComplete)
				.catch(updateConfigFailed);

			function updateConfigComplete(response) {
				return response.data;
			}

			function updateConfigFailed(error) {
				return undefined;
			}
		}

		function buildUrl(params, extraParams, sort, doCount, excludeMultiselect) {
			var factories = leanFilterService.getFactoryList();
			var url;
			if (!params.noFactory) {
				url = URLS.apiPrefix + String.format(params.url, factories);
			}
			else {
				url = URLS.noFactoryPrefix + String.format(params.url, factories);
			}

			var qParams = '';
			if (!params.noPaging && !doCount && params.number) {
				qParams = appendQueryParam(qParams, 'start', params.start);
				qParams = appendQueryParam(qParams, 'limit', params.number);
			}

			if (params.isBackendGrouping && params.grouped) {
				qParams = appendQueryParam(qParams, 'rowsGroup', params.grouped);
			}
			// Undefined checks added because arrays are initialized with empty insides, but not undefined.
			if (sort !== undefined) {
				if (sort[0] !== undefined) {
					qParams = appendQueryParam(qParams, 'sort', encodeURI(JSON.stringify(sort)));
				}
			}

			for (var i = 0; i < extraParams.length; i++) {
				if (extraParams[i].name !== undefined) {
					qParams = appendQueryParam(qParams, extraParams[i].name, extraParams[i].value);
				}
			}
			if (doCount) {
				qParams = appendQueryParam(qParams, 'count', true);
			}
			url = addFilterQueryParams(url + qParams, excludeMultiselect);

			return url;
		}

		function addFilterQueryParams(url, excludeMultiselect) {
			var filterQueryParam = leanFilterService.getQueryParam(false, excludeMultiselect);

			var parts = url.split('?');
			var qParams = '';
			if (parts.length > 1) {
				qParams = '?' + parts[1];
			}
			for (var i = 0; i < filterQueryParam.length; i++) {
				qParams = appendQueryParam(qParams, filterQueryParam[i].key, filterQueryParam[i].value);
			}
			return parts[0] + qParams;
		}

		function getMultiSelectFilterQueryParams() {
			var data = {};
			var msFilters = leanFilterService.getQueryParam(true, false, true);
			for (var i = 0; i < msFilters.length; i++) {
				data[msFilters[i].key] = msFilters[i].value.toString();
			}
			return jQuery.param(data);
		}

		function trackPageView(reportName, factoryNdxsObject) {
			var state = storeService.getState();
			var factoriesArray = factoryNdxsObject.toString().split(',').sort();
			if (factoriesArray[0] === 'LDNA_A_S') {
				factoriesArray = Object.values(state.globalConfig.user.authFacts)
					.filter(function (f) { return  f.customerNdx === state.globalConfig.customer.id;})
					.map(function (f) {return f.ndx;})
					.sort();
			}
			var factories = factoriesArray.join(',');
			if (state.pageViews.lastViewedReportName !== reportName || state.pageViews.lastViewedSiteFilterSelection !== factories) {
				storeService.dispatch(storeService.actionCreators.setLastViewedReportName(reportName));
				storeService.dispatch(storeService.actionCreators.setLastViewedSiteFilterSelection(factories));
				var trackPageViewsArgs = {
					userNdx: globalConfig.user.id,
					baseReportName: reportName,
					reportSettingsId: state.reportSettings.reportSettingsId,
					ownerNdx: state.reportSettings.userNdx,
					parentUserNdx: state.reportSettings.parentUserNdx,
					factoryNdxsString: factories
				};
				storeService.trackPageView(trackPageViewsArgs);
			}
		}
 	}
})();
